// extracted by mini-css-extract-plugin
module.exports = {"square":"Square_square__3WlfV"};